import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'
import { FormEntry, KVWorkOrdersSelection } from 'types'

const StyledButton = styled.button`
  background: rgba(59, 130, 246, 0.15);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: rgba(96, 165, 250, 0.95);
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.7rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 4px;
  white-space: nowrap;

  &:hover {
    background: rgba(59, 130, 246, 0.25);
    border-color: rgba(59, 130, 246, 0.5);
  }
`

interface ViewWorkOrdersButtonProps {
  inspectionAreaId: string
  workOrders: FormEntry[]
}

export const ViewWorkOrdersButton: FC<ViewWorkOrdersButtonProps> = ({
  inspectionAreaId,
  workOrders,
}) => {
  const { setSelectedMarkup, kestrelModel } = useKestrel()
  const count = workOrders.length

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (!kestrelModel?.id) return
    const workOrdersSelection: KVWorkOrdersSelection = {
      type: 'workOrders',
      id: `workorders-${inspectionAreaId}`,
      kestrelModelId: kestrelModel.id,
      inspectionAreaId,
      workOrders,
    }
    setSelectedMarkup(workOrdersSelection)
  }

  return (
    <StyledButton onClick={handleClick}>
      {count} Work Order{count !== 1 ? 's' : ''}
    </StyledButton>
  )
}
